import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { TimeTrackingSessionCollection } from './time-tracking-session.types';

export function timeTrackingSessionBackend(): Backend<
  TimeTrackingSessionCollection
> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => {
      const bidIdParamValue = getQueryParamValue(query, 'bidId');
      if (!bidIdParamValue.length) {
        throw new Error('Time tracking sessions must be queried by bid ID');
      }

      let params: any = {
        // boolean value to filter sessions with invoice or without
        invoiced: getQueryParamValue(query, 'invoiced')[0],
        invoice_ids: getQueryParamValue(query, 'invoiceId'),
      };

      const timeLastUpdateParamValues = getQueryParamValue(
        query,
        'timeLastUpdated',
      );

      if (timeLastUpdateParamValues.length === 2) {
        params = {
          ...params,
          from_time: timeLastUpdateParamValues[0] / 1000,
          to_time: timeLastUpdateParamValues[1] / 1000,
        };
      }

      return {
        endpoint: `projects/0.1/bids/${bidIdParamValue[0]}/time_tracking_sessions/`,
        params,
      };
    },
    push: (authUid, timeTrackingSession) => {
      const seconds = timeTrackingSession.duration / 1000;
      const startDate = new Date(timeTrackingSession.timeStarted);

      return {
        endpoint: 'projects/createTimeTrackingSession.php',
        asFormData: true,
        payload: {
          bidId: timeTrackingSession.bidId,
          // Any datetime format that php supports is suitable here
          // https://www.php.net/manual/en/datetime.formats.php
          // Since the string specifies a timezone (UTC), it will
          // override the timezone conversion on the backend.
          // https://www.php.net/manual/en/datetime.construct.php
          startDate: startDate.toISOString(),
          seconds,
          note: timeTrackingSession.note,
        },
        isGaf: true,
        method: 'POST',
      };
    },
    set: undefined,
    update: (authUid, session, originalSession) => {
      const { note } = session;
      if (note === undefined) {
        throw new Error('Please provide a valid note');
      }

      const timeTrackingSessionId = originalSession.id;
      return {
        endpoint: `projects/0.1/time_tracking_sessions/${timeTrackingSessionId}`,
        payload: {
          note,
        },
        method: 'PUT',
      };
    },
    remove: (authUid, timeTrackingSessionId, originalTimeTrackingSession) => ({
      endpoint: `projects/0.1/time_tracking_sessions/${timeTrackingSessionId}`,
      method: 'DELETE',
      payload: {},
    }),
  };
}
